// Conversations runs in its own container with its own database, so a build
// deployed where that container is missing must not show the section at all -
// six menu entries leading to 404s is worse than no menu entries. Superusers
// see it regardless, which is how it gets checked on production before it is
// switched on for everyone.
export const OUTREACH_ENABLED = process.env.REACT_APP_OUTREACH_ENABLED === 'true';

export function canSeeOutreach(user) {
  return OUTREACH_ENABLED || !!user?.is_superuser;
}

// The lead queue is a workspace capability, not a build flag: the backend says
// on /users/me whether this team works it.
export function canSeeCrm(user) {
  return !!(user?.is_superuser || user?.workspace?.crm);
}

const REQUIREMENTS = { outreach: canSeeOutreach, crm: canSeeCrm };

export function visibleNavItems(items, user) {
  return items.filter((item) => !item.requires || REQUIREMENTS[item.requires](user));
}

// Which outside translations may be opened beside ours is the backend's call: it knows which keys it holds and
// what each provider does with the text it gets.
export function canCompareWith(user, provider) {
  return !!user?.comparison_providers?.includes(provider);
}
